import { Layout } from "@layouts";
import { Bar } from "@organisms";
import { Input as SInput, Progress } from "@shadcn";
import { useEffect, useState, useContext } from "react";
import { GiftCardOffer, PagePaths, AirdropPagePaths } from "../../../../types";
import { PremiumGiftCardAirdropRequest, Partner } from "@api";
import { AuthContext } from "@auth";
import { PageBreadcrumbs } from "@molecules";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

export type AirdropSelectOfferPageTemplateProps = {
  premiumUsers: any[];
  giftCardOffers: GiftCardOffer[] | null;
  progress: number;
  onContinuePressed: (data: any) => void;
  onReturnPressed: () => void;
  selectedUser: any;
};

export type RowRenderingProps = {
  item: any;
  index: any;
};

export const AirdropSelectOfferPageTemplate = ({
  premiumUsers,
  giftCardOffers,
  progress,
  onContinuePressed,
  onReturnPressed,
  selectedUser,
}: AirdropSelectOfferPageTemplateProps): JSX.Element => {
  const { partner, setSelectedPageIndex } = useContext(AuthContext);
  const { t } = useTranslation();
  
  const [selectedGiftCardOffer, setSelectedGiftCardOffer] = useState<GiftCardOffer | null>(null);
  const [filteredGiftCardOffers, setFilteredGiftCardOffers] = useState<GiftCardOffer[] | null>(giftCardOffers);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const goToPerks = () => {
    setSelectedPageIndex?.(3);
    navigate(`/dashboard/${PagePaths.perks}`);
  };
  const goToAirdropsMain = () => {
    setSelectedPageIndex?.(3);
    navigate(`/dashboard/${PagePaths.airdrop}/main`);
  };
  const goToSelectMembers = () => {
    setSelectedPageIndex?.(3);
    navigate(`/dashboard/${PagePaths.airdrop}/${AirdropPagePaths.selectMembers}`);
  };
  useEffect(() => {
    if (!selectedUser) {
      navigate(`/dashboard/${PagePaths.airdrop}/${AirdropPagePaths.selectMembers}`);
    }
  }, [selectedUser, navigate]);

  useEffect(() => {
    console.log(searchTerm)
    setFilteredGiftCardOffers(giftCardOffers?.filter((item) => item.brandName.toLowerCase().includes(searchTerm.toLowerCase())) ?? []);
    console.log(filteredGiftCardOffers);
  }, [searchTerm]);
  useEffect(() => {
    setFilteredGiftCardOffers(giftCardOffers)
  }, [giftCardOffers])
  
  /* const airdropGiftCardTrigger = () => {
    const airdropGiftCardRequest: PremiumGiftCardAirdropRequest = {premiumPartnerId: partner?. || "", giftCardOfferObjectId: giftCardOffers?.[Number(Object.keys(rowSelection))].id || "", amount: Number(selectorValue), network: giftCardOffers?.[Number(Object.keys(rowSelection))]?.networkName };
  } */

  function renderListItem(offer: GiftCardOffer): React.ReactElement {
    const isSelected = selectedGiftCardOffer === offer;

    return (
      <div className="flex flex-col justify-start truncate m-4 transition transform scale-100 ease-in-out delay-0 duration-200 hover:scale-105">
        <button
          className="truncate"
          onClick={() =>
            isSelected ? setSelectedGiftCardOffer(null) : setSelectedGiftCardOffer(offer)
          }
        >
          <div
            className={`w-56 h-32 box-border rounded-xl overflow-hidden ${
              isSelected
                ? "border-2 border-primary-medium p-1 bg-white"
                : "border border-neutral-light"
            }`}
          >
            <img
              src={offer?.images?.[0]?.imageUrl}
              className="w-full h-full rounded-lg object-cover"
            />
          </div>
        </button>
        <div className="w-56 truncate pt-1">
        {offer?.brandName}
        </div>
      </div>
    );
  }

  const renderItem = ({ item, index }: RowRenderingProps) => {
    if (!item) return null;

    return (
      <div className="flex flex-row text-clip overflow-hidden">
        {renderListItem(item)}
      </div>
    );
  };

    // if (index % 4 === 0) {
    //   // render a pair of 2 cards
    //   return renderRow(
    //     filteredGiftCardOffers ? filteredGiftCardOffers?.[index] : null,
    //     filteredGiftCardOffers && index + 1 < filteredGiftCardOffers?.length
    //       ? filteredGiftCardOffers?.[index + 1]
    //       : null,
    //       filteredGiftCardOffers && index + 2 < filteredGiftCardOffers?.length
    //       ? filteredGiftCardOffers?.[index + 2]
    //       : null,
    //       filteredGiftCardOffers && index + 3 < filteredGiftCardOffers?.length
    //       ? filteredGiftCardOffers?.[index + 3]
    //       : null,
    //   );
    // } else {
    //   return null;
    // }


    // function renderRow(
  //   offer1: GiftCardOffer | null,
  //   offer2: GiftCardOffer | null,
  //   offer3: GiftCardOffer | null,
  //   offer4: GiftCardOffer | null,
  // ): React.ReactElement {
  //   return (
  //     <div className="flex flex-row text-clip overflow-hidden">
  //       {offer1 && renderListItem(offer1)}
  //       {offer2 && renderListItem(offer2)}
  //       {offer3 && renderListItem(offer3)}
  //       {offer4 && renderListItem(offer4)}
  //     </div>
  //   );
  // }

  return (
    <Layout
      variant="dashboard"
      header={t("airdrop.common.header")}
      subheader={
        <div className="flex flex-row items-start justify-between max-w-5xl">
          <div className="page-subtitle mt-2">
            {t("airdrop.common.subheader")}
          </div>
        </div>
      }
    >
      <div className="flex flex-col h-full">
        <PageBreadcrumbs
          items={[
            { label: t("airdrop.common.breadcrumbs.benefits"), onClick: goToPerks },
            { label: t("airdrop.common.breadcrumbs.airdrops"), onClick: goToAirdropsMain },
            { label: t("airdrop.common.breadcrumbs.selectMembers"), onClick: goToSelectMembers },
            { label: t("airdrop.common.breadcrumbs.selectGiftCard") },
          ]}
        />

        <div className="flex flex-col gap-6 border border-neutral-light bg-white rounded-2xl w-full min-w-[400px] p-6">
          <div className="">
            <h2 className="text-xl font-normal">
              <div className="flex items-center gap-3 leading-none p-[5px]">
                <span className="flex items-center justify-center w-11 h-11 rounded-full bg-white border border-neutral-light text-2xl leading-none">
                  2.
                </span>
                <span className="flex items-center gap-2 leading-none">
                  {t("airdrop.selectOffers.title")}
                </span>
              </div>
            </h2>
          </div>
          <div className="flex items-center">
            <div className="relative w-full max-w-sm">
              <SInput
                placeholder={t("airdrop.selectOffers.searchPlaceholder")}
                value={searchTerm ?? ""}
                onChange={(event) => {
                  setSearchTerm(event.target.value);
                }}
                className="w-full pr-10 input-focus-primary"
              />
              {searchTerm ? (
                <button
                  type="button"
                  onClick={() => setSearchTerm("")}
                  className="absolute inset-y-0 right-3 flex items-center text-neutral-medium hover:text-neutral-dark focus:outline-none"
                  aria-label="Clear search"
                >
                  <X className="h-4 w-4" />
                </button>
              ) : null}
            </div>
          </div>
          {giftCardOffers?.length ? (
            <div className="flex flex-row flex-wrap h-full pb-16">
              {filteredGiftCardOffers?.map((item, index) => renderItem({ item, index }))}
            </div>
          ) : (
            <div>{t("airdrop.selectOffers.loading")}</div>
          )}
        </div>
        <Bar
          variant="bottom"
          onReturnPressed={onReturnPressed}
          onContinuePressed={() =>
            onContinuePressed(
              selectedGiftCardOffer,
            )}
          isContinueDisabled={selectedGiftCardOffer === null}
        />
      </div>
    </Layout>
  );
};
